import { render, staticRenderFns } from "./YMMappingConfigCompoment.vue?vue&type=template&id=d8fa361a"
import script from "./YMMappingConfigCompoment.vue?vue&type=script&lang=js"
export * from "./YMMappingConfigCompoment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports